'use client';

import { useState } from 'react';

import { Check, AlertCircle } from 'lucide-react';
import { Alert, AlertDescription } from 'components/ui/alert';
import { Checkbox } from 'components/ui/checkbox';
import { Label } from 'components/ui/label';
import { useCertification } from '../contexts/certification-context';

export function ContentStep({ step }: { step: number }) {
  const { selectedCertificate, contentsReviewed, setContentsReviewed } = useCertification();

  const [hasConfirmed, setHasConfirmed] = useState(false);
  const [attemptedContinue, setAttemptedContinue] = useState(false);

  const handleConfirm = () => {
    if (!hasConfirmed) {
      setAttemptedContinue(true);
      return;
    }

    // all unique steps are completed
    setContentsReviewed(Array.from(new Set([...contentsReviewed, step])));
  };

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold">{selectedCertificate?.steps[step].title}</h2>
      {selectedCertificate?.steps[step].content}
      {/* <p className="text-muted-foreground">
        Please review the following important information for your{' '}
        {selectedCertificate?.title || 'certification'} before proceeding.
      </p>

      <div className="space-y-6 bg-gray-50 p-6 rounded-lg border border-gray-200">
        <h3 className="text-xl font-semibold">
          {selectedCertificate?.title || 'Certification'} Requirements
        </h3>

        <div className="space-y-4">
          <p>
            This certification requires you to understand and acknowledge the following key points:
          </p>

          {selectedCertificate?.requirements ? (
            <ul className="list-disc pl-5 space-y-2">
              {selectedCertificate.requirements.map((requirement, index) => (
                <li key={index}>{requirement}</li>
              ))}
            </ul>
          ) : (
            <ul className="list-disc pl-5 space-y-2">
              <li>You must complete all steps of this certification process in order.</li>
              <li>
                The certification is valid for a period of 12 months from the date of completion.
              </li>
              <li>You are responsible for maintaining compliance with all relevant regulations.</li>
              <li>
                This certification may need to be renewed annually or when significant changes
                occur.
              </li>
              <li>
                Your digital signature on the certificate constitutes a legally binding
                acknowledgment.
              </li>
            </ul>
          )}

          <p className="font-medium">
            Please take the time to thoroughly review all materials provided in this certification
            process.
          </p>
        </div>
      </div> */}

      {!contentsReviewed.includes(step) && (
        <div className="flex items-center space-x-2 pt-4">
          <Checkbox
            id="confirm"
            checked={hasConfirmed}
            onCheckedChange={(checked) => {
              setHasConfirmed(checked === true);
              setContentsReviewed(Array.from(new Set([...contentsReviewed, step])));
              setAttemptedContinue(false);
            }}
          />
          <Label htmlFor="confirm" className="text-sm">
            Jeg har læst og forstået de oplysninger, der er givet i dette trin.
          </Label>
        </div>
      )}

      {attemptedContinue && !hasConfirmed && (
        <Alert variant="destructive" className="flex items-center gap-2 bg-red-50">
          <div>
            <AlertCircle className="h-4 w-4" />
          </div>
          <AlertDescription>
            Du skal bekræfte, at du har læst og forstået oplysningerne, før du kan fortsætte.
          </AlertDescription>
        </Alert>
      )}

      {contentsReviewed.includes(step) && (
        <Alert className="flex items-center gap-2  bg-green-50 border-green-200">
          <div>
            <Check className="h-4 w-4 text-green-800" />
          </div>
          <AlertDescription className="text-green-800">
            Du har bekræftet, at du har læst og forstået oplysningerne. Du kan nu fortsætte til
            næste trin.
          </AlertDescription>
        </Alert>
      )}
    </div>
  );
}
